/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Financial } from '../../models/financial';

export interface FinancialGetInsuranceList$Params {
  emrpracticeId?: string | null;
  PatientId?: string | null;
  Encounterno?: string | null;
  Billingdate?: string | null;
  RenderingProvider?: string | null;
}

export function financialGetInsuranceList(http: HttpClient, rootUrl: string, params?: FinancialGetInsuranceList$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
  const rb = new RequestBuilder(rootUrl, financialGetInsuranceList.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('Encounterno', params.Encounterno, {});
    rb.query('Billingdate', params.Billingdate, {});
    rb.query('RenderingProvider', params.RenderingProvider, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Financial>;
    })
  );
}

financialGetInsuranceList.PATH = '/financial/insurancelist';
